import { currenciesMap } from "@/components/invoiceArea/currencies"
import { InvoiceData } from "@/types"
import { formatPrice } from "@/utils"
import "./PreviewInvoice.scss";

type Props = {
    previewConfig: InvoiceData
}

export const PreviewInvoice = ({ previewConfig }: Props) => {
    return <div className="preview-invoice">
        <div className="preview-invoice__cardBody">
            <div className="preview-invoice__invoiceName">
                <h2 className="preview-invoice__invoiceTitle">Invoice</h2>
            </div>

            <div className="preview-invoice__billDetails">
                <div className="preview-invoice__billTo">
                    <p className="section-label">BILL TO:</p>
                    <p>{previewConfig.billTo}</p>
                    {previewConfig.billToAddress && <p>{previewConfig.billToAddress}</p>}
                    {previewConfig.billToCountry && <p>{previewConfig.billToCountry}</p>}
                    {previewConfig.billToContact.email && <p>{previewConfig.billToContact.email}</p>}
                    {previewConfig.billToContact.phone && <p>{previewConfig.billToContact.phone}</p>}
                </div>
                <div className="preview-invoice__billFrom">
                    <p className="section-label">BILL FROM:</p>
                    <p>{previewConfig.billFrom}</p>
                    {previewConfig.billFromAddress && <p>{previewConfig.billFromAddress}</p>}
                    {previewConfig.billFromCountry && <p>{previewConfig.billFromCountry}</p>}
                    {previewConfig.billFromEmail && <p>{previewConfig.billFromEmail}</p>}
                    {previewConfig.billFromPhone && <p>{previewConfig.billFromPhone}</p>}
                </div>

            </div>
            <hr />
            <div className="preview-invoice__total">
                <div className="preview-invoice__total-section">
                    <p>Invoice #{previewConfig.invoiceNumber}</p>
                    <p>{previewConfig.invoiceName}</p>
                    <p>Issued: {previewConfig.dateIssued}</p>
                    <p>Due: {previewConfig.dateDue}</p>
                </div>
                <div className="preview-invoice__total-section">
                    <p className="section-label preview-invoice__total-label">TOTAL:</p>
                    <p className="preview-invoice__total-price">
                        {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(previewConfig.totalToPay)}
                    </p>
                </div>
            </div>
            <div className="preview-invoice__tasksContainer">
                <div className="preview-invoice__taskTitleRow">
                    <p className="preview-invoice__task section-label">Item</p>
                    <p className="preview-invoice__cost section-label">Cost</p>
                    <p className="preview-invoice__quantity section-label">QTY</p>
                    <p className="preview-invoice__price section-label">Price</p>
                </div>
                <hr />
                {previewConfig.tasks.map(({ taskName, taskCost, taskQuantity, taskDescription }, i) => <div className="preview__tasks-container" key={i}>
                    <div className="preview-invoice__taskRow">
                        <div className="preview-invoice__task">
                            <p className="preview-invoice__task-content">{taskName}</p>
                            {taskDescription && <pre>{taskDescription}</pre>}
                        </div>
                        <p className="preview-invoice__costContent preview-invoice__task-content">
                            {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(taskCost)}
                        </p>
                        <p className="preview-invoice__quantityContent preview-invoice__task-content">
                            {taskQuantity}
                        </p>
                        <p className="preview-invoice__priceContent preview-invoice__task-content">
                            {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(taskQuantity * taskCost)}
                        </p>
                    </div>
                    {(previewConfig.tasks.length > 1) && <hr />}
                </div>)}
            </div>
            <div className="preview-invoice__paymentTerms">
                <div className="preview-invoice__paymentTermsNotes">
                    {previewConfig.paymentTerms && <div >
                        <p className="section-label">PAYMENT TERMS</p>
                        <pre>{previewConfig.paymentTerms}</pre>
                    </div>}
                    {previewConfig.clientNotes && <div>
                        <p className="section-label">CLIENT NOTES</p>
                        <pre>{previewConfig.clientNotes}</pre>
                    </div>}
                </div>
                <div className="preview-invoice__paymentTermsTotal">
                    <span className="preview-invoice__paymentTermsAmount">
                        <p>Subtotal:</p>
                        <p className="preview-invoice__task-content">
                            {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(previewConfig.totalToPay)}
                        </p>
                    </span>
                    <hr />
                    <span className="preview-invoice__paymentTermsAmount">
                        <p>Total:</p>
                        <p className="preview-invoice__task-content">
                            {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(previewConfig.totalToPay)}
                        </p>
                    </span>
                    <hr />
                    <span className="preview-invoice__paymentTermsAmount">
                        <p>Paid to date:</p>
                        <p className="preview-invoice__task-content">
                            {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(0)}
                        </p>
                    </span>
                    <hr />
                    <span className="preview-invoice__paymentTermsAmount preview-invoice__amount-text">
                        <p>Amount due({currenciesMap.get(previewConfig.currency)?.code}):</p>
                        <p>
                            {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(previewConfig.totalToPay)}
                        </p>
                    </span>
                </div>
            </div>

            {previewConfig.invoiceStub && <div className="preview-invoice__stub-container">
                <hr className="hr-puncture" />
                <span className="preview-invoice__stub-title">Payment stub</span>
                <div className="preview-invoice__invoiceStub">
                    <div className="preview-invoice__billFrom preview-invoice__billFromStub">
                        <p className="section-label">BILL FROM:</p>
                        <p>{previewConfig.billFrom}</p>
                        {previewConfig.billFromAddress && <p>{previewConfig.billFromAddress}</p>}
                        {previewConfig.billFromCountry && <p>{previewConfig.billFromCountry}</p>}
                        {previewConfig.billFromEmail && <p>{previewConfig.billFromEmail}</p>}
                        {previewConfig.billFromPhone && <p>{previewConfig.billFromPhone}</p>}
                    </div>
                    <div className="preview-invoice__stubAmount">
                        <span className="preview-invoice__paymentTermsAmount">
                            <p>Client</p>
                            <p className="preview-invoice__task-content">{previewConfig.billTo}</p>
                        </span>
                        <span className="preview-invoice__paymentTermsAmount">
                            <p>Invoice #</p>
                            <p className="preview-invoice_task-content">{previewConfig.invoiceNumber}</p>
                        </span>
                        <hr />
                        <span className="preview-invoice__paymentTermsAmount">
                            <p>Paid to date:</p>
                            <p className="preview-invoice__task-content">
                                {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(0)}
                            </p>
                        </span>
                        <span className="preview-invoice__paymentTermsAmount">
                            <p>Amount Due ({currenciesMap.get(previewConfig.currency)?.code})</p>
                            <p className="preview-invoice__task-content">
                                {currenciesMap.get(previewConfig.currency)?.symbol}{formatPrice(previewConfig.totalToPay)}
                            </p>
                        </span>
                    </div>
                </div>
                <hr className="hr-puncture" />
            </div>}
        </div>
    </div>
}